export const isTouchDevice = () => 'ontouchstart' in window;
